import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminRoute from '../AdminRoute';
import AdminTable from '../AdminTable';
import './styles.scss';
import { ADMIN_SESSIONS } from '../../routes';
import ConfirmDialog from '../ConfirmDialog';
import CreateSessionMutation from '../../mutations/CreateSession';
import DeleteSessionMutation from '../../mutations/DeleteSession';
import ExportResults from '../../AdminExportResults';
import orderBy from 'lodash/orderBy';
import { SessionForm } from './SessionForm';

class AdminSessions extends Component {
	constructor(props) {
		super(props);
		this.removeData = this.removeData.bind(this);
		this.exportData = this.exportData.bind(this);

		this.state = {
			showUploadErrors: false,
			uploadErrors: '',
			showDialog: false,
			recordIdToRemove: null,
			showForm: false,
			orderFactor: 'time-down',
			sessions: {
				// Columns schema
				columns: [
					{
						label: 'ID',
						key: 'id',
						styles: {
							display: 'none'
						},
						rowColumnStyles: {
							display: 'none'
						}
					},
					{
						label: 'name',
						key: 'name',
						styles: {
							width: '20%'
						},
						rowColumnStyles: {
							width: '20%'
						}
					},
					{
						label: 'created at',
						key: 'createdAt',
						styles: {
							width: '12.5%'
						},
						rowColumnStyles: {
							width: '12.5%'
						}
					},
					{
						label: 'start at',
						key: 'startDate',
						styles: {
							width: '12.5%'
						},
						rowColumnStyles: {
							width: '12.5%'
						}
					},
					{
						label: 'end at',
						key: 'endDate',
						styles: {
							width: '12.5%'
						},
						rowColumnStyles: {
							width: '12.5%'
						}
					},
					{
						label: 'teams',
						key: 'team',
						styles: {
							width: '10%'
						},
						rowColumnStyles: {
							width: '10%'
						}
						
					},
					{
						label: 'scenario',
						key: 'scenario',
						styles: {
							width: '10%'
						},
						rowColumnStyles: {
							width: '10%'
						}

					},
					{
						label: '',
						key: 'actions',
						styles: {
							width: '20%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 20px 0 auto'
						},
						rowColumnStyles: {
							width: '20%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 20px 0 auto'
						}
					}
				],
				// Actions for each row
				actions: [
					{
						key: 'view',
						icon: 'view',
						tooltip: 'View this session',
						to: ADMIN_SESSIONS,
						clicked: null,
						param: 'id'
					},
					{
						key: 'export',
						icon: 'download',
						tooltip: 'Download results',
						to: null,
						clicked: this.exportData,
						param: 'id'
					},
					{
						key: 'remove',
						icon: 'trash',
						tooltip: 'Remove',
						to: null,
						clicked: this.removeData,
						param: 'id'
					}
				],
				rows: []
			},
			form: {
				title: 'Create a Session',
				inputs: [
					{
						type: 'text',
						name: 'name',
						value: '',
						placeholder: 'Session Name'
					}
				],
				upload: 'Upload *.xlsx',
				cta: 'Create New',
				height: 550
			}
		};

		this.setSessions = this.setSessions.bind(this);
		this.onClickAdd = this.onClickAdd.bind(this);
		this.onChangeFormValue = this.onChangeFormValue.bind(this);
		this.setFormValue = this.setFormValue.bind(this);
		this.onClickUpload = this.onClickUpload.bind(this);
		this.createJsonObject = this.createJsonObject.bind(this);
		this.resetFields = this.resetFields.bind(this);
		this.onClose = this.onClose.bind(this);
		this.toggleDialog = this.toggleDialog.bind(this);
		this.onClickConfirm = this.onClickConfirm.bind(this);
		this.onClickOrderByAZ = this.onClickOrderByAZ.bind(this);
		this.onClickOrderByTime = this.onClickOrderByTime.bind(this);
	}

	componentDidMount() {
		this.setSessions(this.props.sessions);
	}

	setSessions(data = []) {
		let sessions = { ...this.state.sessions };

		sessions.rows = data;

		this.setState({
			sessions
		});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.sessions !== nextProps.sessions) {
			this.setSessions(nextProps.sessions);
		}
	}

	onClickAdd(event) {
		event.preventDefault();

		const showForm = !this.state.showForm;

		this.setState(
			{
				showForm
			},
			() => this.resetFields()
		);
	}

	exportData(ev) {
		const sessionID = ev.target.getAttribute('data-id');
		ExportResults(sessionID);
	}

	resetFields() {
		const form = { ...this.state.form };

		form.inputs.forEach(item => {
			item.value = '';
		});

		setTimeout(() => {
			this.setState({
				form
			});
		}, 800);
	}

	setFormValue(field, value) {
		const form = { ...this.state.form };

		form.inputs.forEach(item => {
			item.value = item.name === field ? value : item.value;
		});

		this.setState({
			form
		});
	}

	onChangeFormValue(ev) {
		ev.preventDefault();

		const inputName = ev.target.name;
		const value = ev.target.value;

		this.setFormValue(inputName, value);
	}

	onClickUpload(ev) {
		ev.preventDefault();
	}

	createJsonObject(createSession) {
		const {
			form: { inputs }
		} = this.state;

		let data = inputs.reduce(
			(acc, cur) => ({ ...acc, [cur.name]: cur.value }),
			{}
		);

		createSession({
			variables: {
				name: data.name,
				owners: []
			}
		});

		const showForm = false;

		this.setState(
			{
				showForm
			},
			() => this.resetFields()
		);
	}

	onClose(ev) {
		/* ev.preventDefault(); */

		this.setState(
			{
				showForm: false
			}/* ,
			() => this.resetFields() */
		);
	}

	removeData(ev) {
		ev.preventDefault();
		const recordIdToRemove = ev.target.getAttribute('data-id');
		this.setState(
			{
				recordIdToRemove
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	toggleDialog() {
		let showDialog = !this.state.showDialog;

		this.setState({
			showDialog
		});
	}

	onClickConfirm(deleteSession) {
		const sessionID = this.state.recordIdToRemove;
		deleteSession({ variables: { sessionID } });
		this.setState(
			{
				recordIdToRemove: null
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	onClickOrderByAZ() {
		const { orderFactor } = this.state;
		this.setState({
			orderFactor: orderFactor === 'a-z' ? 'z-a' : 'a-z'
		});
	}

	onClickOrderByTime() {
		const { orderFactor } = this.state;
		this.setState({
			orderFactor: orderFactor === 'time-down' ? 'time-up' : 'time-down'
		});
	}

	render() {
		const {
			sessions,
			showForm,
			form,
			showDialog,
			recordIdToRemove,
			orderFactor
		} = this.state;
		let orderedSessions = { ...sessions };
		const sessionsRows = sessions.rows.map(session => ({
			...session,
			nameRaw: session.name.toLowerCase()
		}));
		switch (orderFactor) {
		case 'a-z':
			orderedSessions.rows = orderBy(sessionsRows, ['nameRaw'], ['asc']);
			break;
		case 'z-a':
			orderedSessions.rows = orderBy(sessionsRows, ['nameRaw'], ['desc']);
			break;
		case 'time-up':
			orderedSessions.rows = orderBy(sessionsRows, ['createdAtRaw'], ['asc']);
			break;
		case 'time-down':
			orderedSessions.rows = orderBy(
				sessionsRows,
				['createdAtRaw'],
				['desc']
			);
			break;
		}
		return (
			<CreateSessionMutation>
				{createSession => (
					<DeleteSessionMutation>
						{deleteSession => (
							<div className="AdminSessions">
								{showDialog && (
									<ConfirmDialog
										id={recordIdToRemove}
										title={'Deleting session'}
										description={
											'Are you sure you want to delete this session?<br />Once deleted it cannot be recovered.'
										}
										icon={'trash'}
										show={showDialog}
										confirmClicked={() => this.onClickConfirm(deleteSession)}
										closeDialogClicked={this.toggleDialog}
									/>
								)}

								<AdminRoute
									title="Sessions"
									subTitle="Sessions Played"
									icon="sessionsColor"
									form={
										<SessionForm
											changed={this.onChangeFormValue}
											submitted={() => this.createJsonObject(createSession)}
											clicked={this.onClickUpload}
											closed={this.onClose}
											form={form}
											show={showForm}
											scenarios={this.props.scenarios}
										/>
									}
									buttonTheme="orange"
									buttonCta="Add session"
									buttonClicked={this.onClickAdd}
								>
									<div className="AdminSessions-order-filters">
										order by:
										<button
											onClick={this.onClickOrderByAZ}
											className={
												orderFactor === 'z-a' || orderFactor === 'a-z'
													? 'active'
													: null
											}
										>
											{orderFactor === 'z-a' ? 'z-a' : 'a-z'}
										</button>
										<button
											onClick={this.onClickOrderByTime}
											className={
												orderFactor === 'time-up' || orderFactor === 'time-down'
													? 'active'
													: null
											}
										>
											{orderFactor === 'time-up'
												? 'created at △'
												: 'created at ▽'}
										</button>
									</div>
									<AdminTable
										table={orderedSessions}
										emptyMessage={'No sessions found'}
										numberOfRows={sessions.rows.length}
										limit={5}
									/>
								</AdminRoute>
							</div>
						)}
					</DeleteSessionMutation>
				)}
			</CreateSessionMutation>
		);
	}
}

AdminSessions.propTypes = {
	sessions: PropTypes.arrayOf(PropTypes.object)
};

export default AdminSessions;
